import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Logo from './logo'
import Grid from '@material-ui/core/Grid'
import Container from '@material-ui/core/Container'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'

const useStyles = makeStyles(theme => ({
  header: {
    width: '100%',
    background: 'linear-gradient(rgb(137, 44, 59) 0%, rgb(105, 33, 45) 100%)',
  },
  container: {
    padding: 24,
    display: 'flex',
    alignItems: 'center',
  },
  logoWrapper: {
    maxWidth: 160,
    margin: '0 auto',
  },
  titleWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
  },
  title: {
    color: 'white',
    fontFamily: 'Montserrat, Arial, sans-serif',
    textTransform: 'uppercase',
    fontSize: 40,
  }
}))

const Header = ({ siteTitle }) => {
  const classes = useStyles()

  return (
    <header className={ classes.header }>
      <Container className={ classes.container } maxWidth='md'>
        <Grid item xs={12}>
          <Grid container justify="center" alignItems='center' spacing={3}>
            <Grid item xs={12} md={2}>
              <Box className={ classes.logoWrapper }>
                <Logo/>
              </Box>
            </Grid>
            <Grid item xs={12} md={10}>
              <Box className={ classes.titleWrapper }>
                <Typography variant="h3" component="h1" className={ classes.title }>
                  <b>Membership Application</b>
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </header>
  )
}

export default Header
